import { Product, ProductAbbreviations } from '@/creditflowresearch/domain/Product';
import { SEPARATOR } from '@/creditflowresearch/application/SearchHeaderMenu/constants';
import { HeaderMappingItem } from '@/creditflowresearch/application/actions/profile/helpers/types';
import ITools from '@/creditflowresearch/domain/vo/ITools';

export interface IValidationResult {
  isValid: boolean,
  activeMapping?: {
    tools: ITools[],
    productAbbreviation: string,
    regionAbbreviation: string,
  },
  productAbbreviation?: ProductAbbreviations,
}

class ToolValidator {
  static validate(
    mapping: Record<string, HeaderMappingItem>,
    panelId: string,
    isHeaderInitialized: boolean,
    regionId: string,
  ): IValidationResult {
    if (!isHeaderInitialized || !mapping) {
      return { isValid: false };
    }

    const mappingKey = `${ panelId }${ SEPARATOR }${ regionId }`;
    const activeMapping = mapping[mappingKey];

    if (!activeMapping?.tools) {
      return { isValid: false };
    }

    const productAbbreviation = Product.getAbbreviation(panelId);
    if (!productAbbreviation) {
      return { isValid: false };
    }

    return {
      isValid: true,
      activeMapping: {
        tools: activeMapping.tools,
        productAbbreviation: activeMapping.productAbbreviation,
        regionAbbreviation: activeMapping.regionAbbreviation,
      },
      productAbbreviation: productAbbreviation as ProductAbbreviations,
    };
  }
}

export default ToolValidator;
